
import { ActionTree } from 'vuex'
import {AxiosResponse, AxiosError} from "axios";
import moment from 'moment';
// @ts-ignore
import Api from "@/api.js";

export const actions: ActionTree<any, any> = {

    loadRecruitmentSources: ({state, getters, commit, dispatch}, force) => {

        if (force) state.expires = null;

        // Pull from store if loaded and cache hasn't expired
        if (state.expires && moment().isBefore(state.expires)) {
            return state.data;
        }

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            Api.get('/recruitment-sources')

                .then(({data}: AxiosResponse) => {

                    commit('setData', data.data);
                    commit('setLoading', false);
                    resolve(data.data);
                })
                .catch((error: AxiosError) => {

                    commit('setLoading', false);
                    reject(error);
                });
        });
    },

    update: ({state, getters, commit, dispatch}, form) => {

        const backup = [...state.recruitmentSources];

        commit('update', form.data);

        return new Promise((resolve, reject) => {

            Api.put('/recruitment-sources/'+form.data.id, form.data)

                .then((response: AxiosResponse) => {

                    commit('update', response.data.data);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setData', backup);
                    reject(error);
                });
        });
    },

    create: ({state, getters, commit, dispatch}, form) => {

        const backup = [...state.recruitmentSources];

        return new Promise((resolve, reject) => {

            Api.post('/recruitment-sources', form.data)

                .then((response: AxiosResponse) => {
                    commit('create', response.data.data);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setData', backup);
                    reject(error);
                });
        });
    },

    delete: ({state, getters, commit, dispatch}, id) => {

        const backup = [...state.recruitmentSources];

        commit('delete', id);

        return new Promise((resolve, reject) => {

            Api.delete('/recruitment-sources/'+id)

                .then(({data}: AxiosResponse) => {
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setData', backup);
                    reject(error);
                });
        });
    },
};
